import React from "react"
import {Dispatch} from "redux"
import {connect} from "react-redux"

// Actions
import {sendUserInactive} from "../store/actions"

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    sendUserWasInactive: () => dispatch(sendUserInactive())
});

/**
 * @param BaseComponent
 */
export default (BaseComponent: React.ComponentType<any>) => connect(null, mapDispatchToProps)(BaseComponent)

export type WithInactivityWSEvent = {
    sendUserWasInactive(): void
}
